import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/document/';

class DocumentService {
    getAllDocs() {
        return axioscommon.get(API_URL, { headers: authHeader() });
    }
    saveDocument(data) {
        return axioscommon.post(API_URL, data, { headers: authHeader() });
    }
    updateDocument(id, data) {
        return axioscommon.put(API_URL + id, data, { headers: authHeader() });
    }
    getReport() {
        return axioscommon.get(API_URL + 'report/', { headers: authHeader() });
    }
}

export default new DocumentService();
